import * as React from 'react';
import * as styles from './styles.css';

interface ISalesPieChartProps {
  percentage: number;
}

export function SalesPieChart({ percentage }: ISalesPieChartProps) {
  const offset = (percentage * 31.42) / 100;

  return (
    <svg className={styles['pie-chart']} height="24" width="24" viewBox="0 0 20 20">
      <circle r="9.7" cx="10" cy="10" fill="#0468FF" />
      <circle
        r="5"
        cx="10"
        cy="10"
        fill="transparent"
        stroke="#E8E9EC"
        strokeWidth="10"
        transform="rotate(-90 10 10)"
        strokeDasharray={`${offset} 31.42`}
      />
      <circle r="7" cx="10" cy="10" fill="white" />
    </svg>
  );
}
